import React, { useState } from 'react';
import { INFO_REKRUTMEN } from './infoRekrutmen';

// Urutkan biar info "penting" (peringatan penipuan) selalu paling depan
const URUTAN = [...INFO_REKRUTMEN].sort((a, b) => (a.tipe === 'penting' ? -1 : b.tipe === 'penting' ? 1 : 0));

export default function InfoRekrutmenBanner({ onLihatSemua }) {
  const [dibuka, setDibuka] = useState(null); // id item yang lagi di-expand

  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between px-0.5">
        <p className="text-xs font-semibold uppercase tracking-wide" style={{ color: 'var(--text-muted)' }}>
          📢 Info Tryout & Rekrutmen
        </p>
        {onLihatSemua && (
          <button onClick={onLihatSemua} className="text-[11px] font-semibold" style={{ color: 'var(--accent)' }}>
            Lihat semua →
          </button>
        )}
      </div>

      <div className="flex gap-2.5 overflow-x-auto pb-1 -mx-5 px-5" style={{ scrollbarWidth: 'none' }}>
        {URUTAN.map(n => {
          const terbuka = dibuka === n.id;
          return (
            <button key={n.id} onClick={() => setDibuka(terbuka ? null : n.id)}
              className="text-left rounded-xl p-3.5 flex-shrink-0 transition-all"
              style={{
                width: terbuka ? 260 : 220,
                backgroundColor: 'var(--bg-card2)',
                border: `1px solid ${n.tipe === 'penting' ? n.warna : 'var(--border)'}`,
              }}>
              <div className="flex items-center gap-2 mb-1.5">
                <span className="text-base">{n.icon}</span>
                <span className="text-[10px] font-semibold px-1.5 py-0.5 rounded-full"
                      style={{ backgroundColor: `${n.warna}20`, color: n.warna }}>
                  {n.waktu}
                </span>
              </div>
              <p className="text-xs font-bold leading-tight mb-1" style={{ color: 'var(--text-primary)' }}>
                {n.judul}
              </p>
              <p className={`text-[11px] leading-relaxed ${terbuka ? '' : 'line-clamp-2'}`}
                 style={{ color: 'var(--text-muted)' }}>
                {n.isi}
              </p>
            </button>
          );
        })}
      </div>
    </div>
  );
}
